import React, { Component } from 'react'

import Vets from '../../components/Vets'
import Services from '../../components/Services'
import Page from '../../components/Page'
import Gallery from '../../components/Gallery'
import Modal from 'react-modal'
import { RichText } from 'prismic-reactjs'

import './style.css'

const customModalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: 0,
    maxHeight: '80%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
  },
  overlay: {
    zIndex: 1000,
  },
}

class Home extends Component {
  render() {
    return (
      <Page title="Buda-Vet Allatorvosi Rendelo">
        <Gallery
          pictures={this.props.pictures}
          description={this.props.description}
        />
        <a className="anchor" id="vets" />
        <div className="sectionTitle">Állatorvosaink</div>
        <Vets vets={this.props.vets} />
        <a className="anchor" id="services" />
        <div className="sectionTitle">Szolgáltatásaink</div>
        <div className="mid">
          <Services services={this.props.services} />
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={!!(this.props.isMainModalOpen && this.props.mainNews.length)}
          style={customModalStyle}
          onRequestClose={this.props.closeMainModal}>
          <div className="mainNewsContent">
            {RichText.render(this.props.mainNews)}
          </div>
          <div className="closeButtonContainer">
            <div className="closeButton" onClick={this.props.closeMainModal}>
              Bezárás
            </div>
          </div>
        </Modal>
      </Page>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home/index.js